import React from "react";
import Hero from "./Hero";
import AcademicInfo from "./AcademicInfo";

function AcademicsPage() {
  return (
    <>
      <Hero />
      <AcademicInfo />
    </>
  );
}

export default AcademicsPage;
